import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { Entities, Projection } from 'src/common';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import TableHelper from 'src/utils/table-helper';
import _ from 'lodash';
import CalendarSeasonModal from 'src/components/administration/calendar-season/components/calendar-season-modal';
import { IconLabel } from 'src/components/administration/IconLabel';

class CalendarSeasonAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.tableHelper = new TableHelper();

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        this.props.fetchByCompanyId(Entities.CALENDAR_SEASON, this.props.selectedCompany, Projection.LIST);
        this.props.fetchByCompanyId(Entities.CALCULATION, this.props.selectedCompany, Projection.FULL);
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.calendarSeason,
                this.props.calendarSeason,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    componentWillReceiveProps(nextProps) {
        const { calendarSeason } = nextProps;

        if (calendarSeason.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });
        this.tableHelper.processPagination(calendarSeason.items.length);

        if (!_.isEqual(calendarSeason, this.props.calendarSeason)) {
            this.setState({ calendarSeason: nextProps.calendarSeason });
        }
    }

    calendarColorFormatter(cell) {
        return (
            <div
                style={{
                    backgroundColor: cell || 'transparent',
                    width: '24px',
                    height: '24px',
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                }}
                title={cell}
            />
        );
    }

    tableActionsFormatter(cell, calendarSeason) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() =>
                        this.props.openModal({
                            component: CalendarSeasonModal,
                            componentProps: {
                                id: calendarSeason.entity.id,
                                isCreate: false,
                            },
                            title: calendarSeason.name,
                            mandatoryFields: true,
                        })
                    }>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
                {/*<button*/}
                {/*    type="button"*/}
                {/*    className="btn btn-xs transparent"*/}
                {/*    title={t('user_functionality.delete')}*/}
                {/*    onClick={() => this.openConfirmDeleteDialog(discountGroup)}>*/}
                {/*    <span className="glyphicon glyphicon-trash text-danger" />*/}
                {/*</button>*/}
            </div>
        );
    }

    render() {
        const { t, calendarSeason, calculations } = this.props;

        const finishFetching = this.state.startedFetching && !calendarSeason.isFetching;
        const tableData = [];

        if (finishFetching && calendarSeason.items.length > 0) {
            calendarSeason.items.map(calc => {
                tableData.push({
                    id: calc.id,
                    name: calc.name,
                    calendarColor: calc.calendarColor,
                    entity: calc,
                });
            });
        }

        return (
            <>
                <legend className="legend">
                    {t('calendar_season_calculation.seasons_title')}
                    <button
                        className="btn btn-xs btn-blue pull-right"
                        onClick={() => {
                            if (this.table) this.table.reset();
                            this.props.openModal({
                                component: CalendarSeasonModal,
                                componentProps: {
                                    isCreate: true,
                                    calculations: calculations.items,
                                },
                                title: t('calendar_season_calculation.create_season'),
                                mandatoryFields: true,
                            });
                        }}>
                        <IconLabel icon="plus" text={t('calendar_season_calculation.create_season')} />
                    </button>
                </legend>
                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        ref={ref => (this.table = ref)}
                        data={tableData}
                        exportCSV={true}
                        striped={true}
                        hover={true}
                        condensed={true}
                        pagination={true}
                        options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                        searchPlaceholder={t('common_phrases.search')}
                        search={true}>
                        <TableHeaderColumn columnTitle={true} dataField="id" hidden={true} isKey={true} export={true} />
                        <TableHeaderColumn columnTitle={true} dataField="name" dataSort={true}>
                            {t('common_phrases.name')}
                        </TableHeaderColumn>

                        <TableHeaderColumn
                            columnTitle={true}
                            dataFormat={this.calendarColorFormatter}
                            dataField="calendarColor"
                            dataSort={false}>
                            {t('calendar_season_calculation.form.color_calendar')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="actions"
                            width="90"
                            dataFormat={this.tableActionsFormatter}
                            export={false}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </>
        );
    }
}

export default withTranslation()(composeModalActions(CalendarSeasonAdministration));
